module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"jump":"Jump to","please_enter_page_to_jump":"Please enter target page number","incorrect_page":"Invalid page to jump to."},"zh":{"jump":"跳頁","please_enter_page_to_jump":"請輸入目標頁數","incorrect_page":"請輸入正確的頁數"}}')
  delete Component.options._Ctor
}
